import { render, staticRenderFns } from "./Postsalesservice.vue?vue&type=template&id=279e6c8c&scoped=true&"
import script from "./Postsalesservice.vue?vue&type=script&lang=js&"
export * from "./Postsalesservice.vue?vue&type=script&lang=js&"
import style0 from "./Postsalesservice.vue?vue&type=style&index=0&id=279e6c8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e6c8c",
  null
  
)

export default component.exports